import { AgencyDetails as DefaultAgencyDetails } from "src/components/feature/Onboarding";

const AgencyDetails = () => {
  return <DefaultAgencyDetails />;
};

export default AgencyDetails;
